import reddit from './platforms/reddit'
import instagram from './platforms/instagram'
import facebook from './platforms/facebook'
import threads from './platforms/threads'
import twitter from './platforms/twitter'
import tiktok from './platforms/tiktok'
import youtube from './platforms/youtube'
import pinterest from './platforms/pinterest'
import bluesky from './platforms/bluesky'
import mastodon from './platforms/mastodon'
import tumblr from './platforms/tumblr'

export const PLATFORM_CODE_REDDIT = reddit.code
export const PLATFORM_CODE_TWITTER = twitter.code
export const PLATFORM_CODE_THREADS = threads.code
export const PLATFORM_CODE_INSTAGRAM = instagram.code
export const PLATFORM_CODE_FACEBOOK = facebook.code
export const PLATFORM_CODE_TIKTOK = tiktok.code
export const PLATFORM_CODE_YOUTUBE = youtube.code
export const PLATFORM_CODE_PINTEREST = pinterest.code
export const PLATFORM_CODE_BLUESKY = bluesky.code
export const PLATFORM_CODE_TUMBLR = tumblr.code
export const PLATFORM_CODE_MASTODON = mastodon.code

export const platforms = [
  reddit,
  twitter,
  threads,
  instagram,
  facebook,
  tiktok,
  youtube,
  pinterest,
  bluesky,
  tumblr,
  mastodon
]

/**
 * Platforms that are not Reddit. These all follow the same new pattern.
 */
export const newPlatforms = platforms.filter(
  (p) => p.code !== PLATFORM_CODE_REDDIT
)

export const platformCodes = platforms.map((platform) => platform.code)

export const newPlatformCodes = newPlatforms.map((platform) => platform.code)

export const platformNames = platforms.map((platform) => platform.name)

// Optimization to avoid looping through the platforms array all the time.
const _platformsByCode = platforms.reduce((acc, platform) => {
  acc[platform.code] = platform
  return acc
}, {})

export function getPlatform(code) {
  return _platformsByCode[code.toLowerCase().trim()]
}

export function getPlatformName(code) {
  return getPlatform(code).name
}

export function getPlatformIcon(code) {
  return getPlatform(code).icon
}
